import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize Firebase
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyBvOkcHhHhHhHhHhHhHhHhHhHhHhHhHhHh",
  authDomain: "jsonbox-12345.firebaseapp.com",
  projectId: "jsonbox-12345",
  storageBucket: "jsonbox-12345.appspot.com",
  messagingSenderId: "123456789",
  appId: "1:123456789:web:abcdefghijklmnop",
  measurementId: "G-ABCDEFGHIJ"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics only in production
if (import.meta.env.PROD) {
  getAnalytics(app)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
